import React from "react";
import "../../styles/windowstyles/Windows95Modal.css";

export default function Windows95Modal({ title = "", location = "", dates="", boxWidth = 200, icon, iconWidth = 18, iconHeight = 18, iconSize = 1, children }) {
  return (
    <div className="windows95-wrapper">
      <div className="box" style={{width:boxWidth}}>
        <div className="title-bar">
          <img
            src={icon || "http://i63.tinypic.com/117hi0p.png"}
            width={iconWidth * iconSize}
            height={iconHeight * iconSize}
            alt="icon"
            className="title-icon"
          />
          <p className="title-text">{location}</p>
          <p className="title-text">{dates}</p>
          <div className="title-buttons">
            <button className="title-button">?</button>
            <button className="title-button">X</button>
          </div>
        </div>

        <div className="body">
          {children || (
            <>
              <p>Welcome to your PC!</p>
              <button>OK</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}